// extracted by mini-css-extract-plugin
export default {"graphicContainer":"Report-module--graphicContainer--170dd"};